// highlight-python (editor build) — a tiny, dependency-free per-line Python syntax
// highlighter for the tweak surface's read-only code pane. Returns SAFE, escaped HTML for
// ONE line, wrapping strings / comments / keywords / numbers in `.pchl-*` spans (styled by
// the host page via design-system tokens).
//
// This is a plain-JS port of src/islands/shared/highlight-python.ts — the editor build
// (rollup, JS entry) cannot import the TS shared module, so the logic is duplicated here.
// KEEP THE TWO IN SYNC (identical token grammar); if one changes, change the other.

var KEYWORDS =
  'def|class|return|if|elif|else|for|while|in|not|and|or|is|import|from|as|with|try|except|finally|raise|global|nonlocal|lambda|yield|pass|break|continue|True|False|None|self';

// One token per match, tried in order: string | comment | keyword | number.
var TOKEN = new RegExp(
  '("(?:[^"\\\\]|\\\\.)*"|\'(?:[^\'\\\\]|\\\\.)*\')' + // 1: string
    '|(#.*)' + // 2: comment (to end of line)
    '|(\\b(?:' + KEYWORDS + ')\\b)' + // 3: keyword
    '|(\\b\\d+(?:\\.\\d+)?\\b)', // 4: number
  'g'
);

function esc(s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Highlight a single source line; returns escaped HTML (safe for innerHTML).
export function highlightPythonLine(line) {
  if (line === '') { return '&nbsp;'; }
  var out = '';
  var last = 0;
  TOKEN.lastIndex = 0;
  var m;
  while ((m = TOKEN.exec(line)) !== null) {
    if (m.index > last) { out += esc(line.slice(last, m.index)); }
    var full = m[0];
    if (m[1]) { out += '<span class="pchl-str">' + esc(m[1]) + '</span>'; }
    else if (m[2]) { out += '<span class="pchl-com">' + esc(m[2]) + '</span>'; }
    else if (m[3]) { out += '<span class="pchl-kw">' + esc(m[3]) + '</span>'; }
    else if (m[4]) { out += '<span class="pchl-num">' + esc(m[4]) + '</span>'; }
    last = m.index + full.length;
    if (full.length === 0) { TOKEN.lastIndex++; } // zero-width guard (defensive)
  }
  if (last < line.length) { out += esc(line.slice(last)); }
  return out || '&nbsp;';
}
